module.exports = "https://cdn.realtymogul.com/static/media/merlinIcons.1befa21e.ttf";